import React, { useMemo } from 'react';
import AppContext from '../../Context/AppContext';

/**
 * Isolated AppContext stub for marketing screenshots only.
 * Does not touch production session or APIs.
 */
const MarketingProvider = ({ children }) => {
    const value = useMemo(
        () => ({
            checkUserSession: () => ({
                token: 'marketing-demo-token',
                userId: 'marketing-demo-user',
                userTypeId: 1,
                firstName: 'Jordan',
                lastName: 'Rivera',
                isShopify: false,
            }),
            changeLoading: () => {},
            changeModalWarningUpgrade: () => {},
            setNewData: () => {},
            getData: () => ({
                dayAddFindDailyActions: { days: 0 },
                repeatAction: null,
                currentAction: null,
            }),
            logOut: () => {},
            updateUserStepId: async () => ({
                userStepId: 4,
                assessmentId: 'marketing-demo-assessment',
                areaId: 0,
            }),
            activeCount: false,
        }),
        []
    );

    return (
        <AppContext.Provider value={value}>{children}</AppContext.Provider>
    );
};

export default MarketingProvider;
